import api from "../../services/api";

const path = "v1/cliente";

export const getCustomers = async (params = "") => {
  return await api.get(`${path}${params}`);
};

export const postCustomer = async ({ params, body }) => {
  return await api.post(`${path}${params}`, body);
};

export const putCustomer = async ({ params, body, cnpj }) => {
  return await api.put(`${path}/${cnpj}${params}`, body);
};
